import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        component: Home,
        redirect: {
            name: "home"
        }
    },
    {
        path: "/home",
        component: resolve => require(["@/views/home/index"], resolve),
        children: [
            {
                path: "/",
                name: "home",
                meta: {
                    title: "万顺代驾",
                    requireAuth: true
                },
                component: resolve => require(["@/views/Home"], resolve)
            },
            {
                path: "fareEstimate",
                name: "fareEstimate",
                meta: {
                    title: "预估费",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/fareEstimate"], resolve)
            },
            {
                path: "accountingRules",
                name: "accountingRules",
                meta: {
                    title: "代驾计费规则",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/accountingRules"], resolve)
            },
            {
                path: "accountingRulesCar",
                name: "accountingRulesCar",
                meta: {
                    title: "代驾计费规则",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/accountingRulesCar"], resolve)
            },
            ,
            {
                path: "accountingRulesFixed",
                name: "accountingRulesFixed",
                meta: {
                    title: "代驾计费规则",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/accountingRulesFixed"], resolve)
            },
            {
                path: "sharingJourney",
                name: "sharingJourney",
                meta: {
                    title: "行程分享",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/sharingJourney"], resolve)
            },
            {
                path: "cancellationRule",
                name: "cancellationRule",
                meta: {
                    title: "取消规则",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/cancellationRule"], resolve)
            },
            {
                path: "costQuestions",
                name: "costQuestions",
                meta: {
                    title: "费用疑问",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/costQuestions"], resolve)
            },
            {
                path: "choiceCoupon",
                name: "choiceCoupon",
                meta: {
                    title: "优惠券",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/choiceCoupon"], resolve)
            },
            {
                path: "coupon",
                name: "coupon",
                meta: {
                    title: "优惠券",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/coupon"], resolve)
            },
            {
                path: "couponInstructions",
                name: "couponInstructions",
                meta: {
                    title: "优惠券使用说明",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/couponInstructions"], resolve)
            },
            {
                path: "fareDetails",
                name: "fareDetails",
                meta: {
                    title: "代驾车费明细",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/fareDetails"], resolve)
            },
            {
                path: "withdrawalRules",
                name: "withdrawalRules",
                meta: {
                    title: "提现规则",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/withdrawalRules"], resolve)
            },
            {
                path: "QA",
                name: "QA",
                meta: {
                    title: "常见问题",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/QA"], resolve)
            },
            {
                path: "serviceAgreement",
                name: "serviceAgreement",
                meta: {
                    title: "万顺代驾服务协议",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/serviceAgreement"], resolve)
            },
            {
                path: "privacyPolicy",
                name: "privacyPolicy",
                meta: {
                    title: "隐私协议",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/privacyPolicy"], resolve)
            },
            {
                path: "prepaymentAgreement",
                name: "prepaymentAgreement",
                meta: {
                    title: "预付款协议",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/prepaymentAgreement"], resolve)
            },
            {
                path: "driverRegistration",
                name: "driverRegistration",
                meta: {
                    title: "万顺代驾司机报名",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/driverRegistration"], resolve)
            },
            {
                path: "messageDetails",
                name: "messageDetails",
                meta: {
                    title: "消息详情",
                    requireAuth: true
                },
                component: resolve => require(["@/views/new/messageDetails"], resolve)
            },
            {
                path: "jumpProgram",
                name: "jumpProgram",
                meta: {
                    title: "跳转小程序",
                    requireAuth: true
                },
                component: resolve => require(["@/views/jump/jumpProgram"], resolve)
            },
            {
                path: "contractAgreement",
                name: "contractAgreement",
                meta: {
                    title: "万顺代驾司机合同协议",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/contractAgreement"], resolve)
            },
            {
                path: "exchangeUniversal",
                name: "exchangeUniversal",
                meta: {
                    title: "万顺代驾兑换码",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/exchangeUniversal"], resolve)
            },
            {
                path: "registrationFee",
                name: "registrationFee",
                meta: {
                    title: "代驾报名费",
                    requireAuth: true
                },
                component: resolve => require(["@/views/registration-fee/registration-fee"], resolve)
            },
            {
                path: "registrationFeeDetails",
                name: "registrationFeeDetails",
                meta: {
                    title: "明细记录",
                    requireAuth: true
                },
                component: resolve => require(["@/views/registration-fee/fee-details"], resolve)
            },
            {
                path: "ownerCertificationUniver",
                name: "ownerCertificationUniver",
                meta: {
                    title: "司机认证",
                    requireAuth: true
                },
                component: () => import("@/views/activity/ownerCertification/ownerCertificationUniver.vue")
            },
            {
                path: "abouteProcess",
                name: "abouteProcess",
                meta: {
                    title: "车主新人指引",
                    requireAuth: true
                },
                component: () => import("@/views/activity/learnAboutCar/abouteProcess.vue")
            },
            {
                path: "toActivityRules",
                name: "toActivityRules",
                meta: {
                    title: "活动规则",
                    requireAuth: true
                },
                component: () => import("@/views/activity/common/toActivityRules.vue")
            },
            {
                path: "ticketUniversal",
                name: "ticketUniversal",
                meta: {
                    title: "领券",
                    requireAuth: true
                },
                component: () => import("@/views/activity/ticketUniversal/ticketUniversal.vue")
            },
            {
                path: "finishOrder",
                name: "finishOrder",
                meta: {
                    title: "代驾车主完单活动",
                    requireAuth: true
                },
                component: () => import("@/views/activity/finishOrder/finishOrder.vue")
            },
            {
                path: "shareUniversal",
                name: "shareUniversal",
                meta: {
                    title: "邀请活动",
                    requireAuth: true
                },
                component: () => import("@/views/activity/shareUniversal/shareUniversal.vue")
            },
            {
                path: "shareInvited",
                name: "shareInvited",
                meta: {
                    title: "邀请活动",
                    requireAuth: true
                },
                component: () => import("@/views/activity/shareUniversal/shareInvited.vue")
            },
            {
                path: "myReward",
                name: "myReward",
                meta: {
                    title: "我的奖励",
                    requireAuth: true
                },
                component: () => import("@/views/activity/shareUniversal/myReward.vue")
            },
            {
                path: "codeTips",
                name: "codeTips",
                meta: {
                    title: "我的奖励",
                    requireAuth: true
                },
                component: () => import("@/views/activity/shareUniversal/codeTips.vue")
            },
            {
                path: "login",
                name: "login",
                meta: {
                    title: "司机登录",
                    requireAuth: true
                },
                component: () => import("@/views/login/login.vue")
            },
            {
                path: "sms",
                name: "sms",
                meta: {
                    title: "司机注册",
                    requireAuth: true
                },
                component: () => import("@/views/login/sms.vue")
            },
            {
                path: "reg",
                name: "reg",
                meta: {
                    title: "司机注册",
                    requireAuth: true
                },
                component: () => import("@/views/login/reg.vue")
            },
            {
                path: "eValuationRules",
                name: "eValuationRules",
                meta: {
                    title: "费用疑问",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/eValuationRules"], resolve)
            },
            {
                path: "recruiting",
                name: "recruiting",
                meta: {
                    title: "万顺代驾司机招募",
                    requireAuth: true
                },
                component: resolve => require(["@/views/activity/recruiting/recruiting"], resolve)
            },
            {
                path: "operatingTutorial",
                name: "operatingTutorial",
                meta: {
                    title: "操作教程",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/operatingTutorial"], resolve)
            },
            {
                path: "performance",
                name: "performance",
                meta: {
                    title: "积分",
                    requireAuth: true
                },
                component: resolve => require(["@/views/performance/index"], resolve)
            },
            {
                path: "performanceDetail",
                name: "performanceDetail",
                meta: {
                    title: "积分详情",
                    requireAuth: true
                },
                component: resolve => require(["@/views/performance/indexDetail"], resolve)
            },
            {
                path: "performanceTypeDetail",
                name: "performanceTypeDetail",
                meta: {
                    title: "积分流水详情",
                    requireAuth: true
                },
                component: resolve => require(["@/views/performance/typeDetail"], resolve)
            },
            {
                path: "complain",
                name: "complain",
                meta: {
                    title: "处罚申诉",
                    requireAuth: true
                },
                component: resolve => require(["@/views/performance/complain"], resolve)
            },
            {
                path: "complainResult",
                name: "complainResult",
                meta: {
                    title: "申诉详情",
                    requireAuth: true
                },
                component: resolve => require(["@/views/performance/complainResult"], resolve)
            },
            {
                path: "platService",
                name: "platService",
                meta: {
                    title: "平台服务费",
                    requireAuth: true
                },
                component: resolve => require(["@/views/order/platService"], resolve)
            },
            {
                path: "msgDetails",
                name: "msgDetails",
                meta: {
                    title: "消息详情",
                    requireAuth: true
                },
                component: resolve => require(["@/views/new/msgDetails"], resolve)
            },
            {
                path: "trainingGuide",
                name: "trainingGuide",
                meta: {
                    title: "培训中心",
                    requireAuth: true
                },
                component: resolve => require(["@/views/activity/guide/trainingGuide"], resolve)
            },
            {
                path: "guideDetail",
                name: "guideDetail",
                meta: {
                    title: "培训中心",
                    requireAuth: true
                },
                component: resolve => require(["@/views/activity/guide/guideDetail"], resolve)
            },
            {
                path: 'behaviorScore',
                name: 'behaviorScore',
                meta: {
                    title: '行为分中心',
                    requireAuth: true,
                },
                component: resolve => require(['@/views/behaviorScore/index'], resolve),
            }, {
                path: 'behaviorScoreDetail',
                name: 'behaviorScoreDetail',
                meta: {
                    title: '行为分变更明细',
                    requireAuth: true,
                },
                component: resolve => require(['@/views/behaviorScore/detail'], resolve),
            },
            {
                path: 'downLoadPayFor',
                name: 'downLoadPayFor',
                meta: {
                    title: '万顺叫车',
                    requireAuth: true,
                },
                component: resolve => require(['@/views/activity/downLoadPayFor/index'], resolve),
            },
            {
                path: 'pressForMoneyDetail',
                name: 'pressForMoneyDetail',
                meta: {
                    title: '催款进度',
                    requireAuth: true,
                },
                component: resolve => require(['@/views/pressForMoney/detail.vue'], resolve),
            },
            {
                path: 'pressForMoneySkill',
                name: 'pressForMoneySkill',
                meta: {
                    title: '催款技巧',
                    requireAuth: true,
                },
                component: resolve => require(['@/views/pressForMoney/skill.vue'], resolve),
            },
            {
                path: 'authorizeInvoicing',
                name: 'authorizeInvoicing',
                meta: {
                    title: '万顺代驾',
                    requireAuth: true,
                },
                component: resolve => require(['@/views/activity/authorizeInvoicing/authorizeInvoicing.vue'], resolve),
            }
        ]
    },
    {
        path: "*",
        meta: {
            title: "404"
        },
        component: () => import("@/views/other/error.vue")
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    //在此处加入以下内容文字链接跳转到默认顶部
    scrollBehavior(to, from, saveTop) {
        if (saveTop) {
            return saveTop;
        } else {
            return {
                x: 0,
                y: 0
            };
        }
    }
});

export default router;
